import "../App.css";

function Home() {
	return (
		<div className="App">
			<header className="App-header">
				<h1>Wizrad Games</h1>
				<p>Callum Delaney, indie game developer</p>
				<p>contact me at: wizradgames@gmail.com</p>
				{/* <img src={logo} className="App-logo" alt="logo" /> */}
				{/* <img src={tiles} alt="tiles" /> */}
			</header>
		</div>
	);
}

export default Home;